import { KeybindSnippet } from "./KeybindSnippet";
import { ScoreboardObjectiveSnippet } from "./ScoreboardObjectiveSnippet";
import { SelectorSnippet } from "./SelectorSnippet";
import { TextSnippet } from "./TextSnippet";
export function genericSnippet(snippet) {
    if (snippet instanceof ScoreboardObjectiveSnippet
        || snippet instanceof KeybindSnippet
        || snippet instanceof SelectorSnippet
        || snippet instanceof TextSnippet) {
        return snippet;
    }
    else {
        return null;
    }
}
